import React from 'react';
import { styled } from '@material-ui/core/styles';
import { TableCell } from '@material-ui/core';

const CustomTableCell = styled(TableCell)({
  padding: '6px 0 !important',
});

export default CustomTableCell;
